import React, { useState } from 'react';
import { Swiper, SwiperSlide  } from 'swiper/react';
import SwiperCore, { Thumbs, Navigation, Pagination } from 'swiper';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';

import { useMediaQuery } from '@material-ui/core';

interface GalleryProps {
  images: string[];
  hideThumbs?: boolean;
}

export default function Gallery({images, hideThumbs = false}: GalleryProps) {
  const isMobile = useMediaQuery(({ breakpoints }) => breakpoints.down('sm'));
  const [thumbsSwiper, setThumbsSwiper] = useState<any>(null);

  SwiperCore.use([Thumbs, Navigation, Pagination]);

  const getImageName = (url: string) => {
    const urlParts = url.split('/');
    const fileName = urlParts[urlParts.length - 1];
    const fileNameParts = fileName.split('.');
    return fileNameParts[0].replace(/[_\-]/g, ' ');
  }

  const createSlides = (imageLink: string, id: number) => (
    <SwiperSlide key={id}>
      <img src={imageLink} alt={getImageName(imageLink)} style={{ width: '100%' }} />
    </SwiperSlide>
  )

  return (
    <div>
      <Swiper
        loop
        pagination={{type: 'bullets'}}
        spaceBetween={10}
        navigation
        className={`gallerySwiper ${images.length === 1 ? 'hide-arrow' : ''}`}
        // @ts-ignore
        thumbs={{swiper: thumbsSwiper}}
      >
        {images.map((image, i) => createSlides(image, i))}
      </Swiper>
      {
        !hideThumbs &&
          <Swiper
            spaceBetween={10}
            slidesPerView={images.length}
            freeMode={true}
            watchSlidesProgress={true}
            className="myThumbsSwiper"
            onSwiper={setThumbsSwiper}
          >
            {images.map((image, i) => createSlides(image, i))}
          </Swiper>
      }

    </div>
  )
}
